import COMPONENT_DATA from './components/data.js';

(async function () {
  customElements.define(
    ('component-name' in document.currentScript.dataset?document.currentScript.dataset['component-name']:'dsb-data'),
    COMPONENT_DATA
  );
})();
